import React from "react";
import Helmet from "react-helmet";
import SocialIcons from "../components/SocialIcons";
import ContactForm from "../components/ContactForm"

class contactPage extends React.Component {
  render() {
    const { acf } = this.props.data.wordpressPage;

    return (
      <div className="wow fadeIn" style={{ visibility: "hidden" }}>
        <Helmet title={`Contact | Moon Beyond Co`} />
        <div className="wow fadeIn contactUsPage_container">
          <div className="container-fluid">
            <div className="row headingSection">
              <div className="col-xs-12 text-center headingContainer">
                <div className="separator-line bg-yellow no-margin-top margin-five" />
                <h1 className="white-text">{acf.page_heading}</h1>
                <h2>{acf.page_subheading}</h2>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row contactForm">
              <div className="col-md-4 col-sm-6 text-left">
                <div dangerouslySetInnerHTML={{ __html: acf.contact_form_description }}></div>
                <div className="text-center">
                  <SocialIcons style={{ textAlign: "center" }} />
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-md-offset-2">
                <ContactForm />
              </div>
            </div>
          </div>
          <img
            className="contactUsPage_image"
            src={acf.image.localFile.childImageSharp.sizes.src}
          />
        </div>
      </div>
    );
  }
}

export default contactPage;

export const query = graphql`
  query contactPageQuery {
    wordpressPage(title: { eq: "Contact" }) {
      acf {
        page_heading
        page_subheading
        contact_form_description
        image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1920) {
                src
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js